module.exports = __webpack_public_path__ + "img/libro.59d61319.svg";